/**
 * A stale expected_revision never silently overwrites — this banner is
 * the only way a conflicted autosave field is ever resolved: the user
 * explicitly keeps their own edit (retried against the fresh revision)
 * or takes the server's current value.
 */
export default function ConflictBanner({ conflict, onKeepMine, onUseServer }) {
  if (!conflict) return null;
  return (
    <div
      className="border border-mustard/40 bg-mustard/10 rounded-lg px-3 py-2 mb-2 flex flex-wrap items-center justify-between gap-2 text-xs"
      data-testid="autosave-conflict-banner"
    >
      <p className="text-ink">This was updated elsewhere while you were editing.</p>
      <div className="flex gap-3 shrink-0">
        <button onClick={onUseServer} className="text-ink-soft hover:text-ink underline" data-testid="autosave-conflict-use-server">
          Use their version
        </button>
        <button onClick={onKeepMine} className="text-terracotta hover:text-terracotta/80 font-medium" data-testid="autosave-conflict-keep-mine">
          Keep mine
        </button>
      </div>
    </div>
  );
}
